// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{margin:0}html,body{height:100%}#page-wrap{min-height:100%}@media (min-width: 600px){#page-wrap{margin-bottom:-135px;padding-bottom:135px}}@media (max-width: 599px){#page-wrap{margin-bottom:-40px;padding-bottom:-40px}}#page-wrap:after{content:\"\";display:block}@media (min-width: 600px){.site-footer,.page-wrap:after{height:135px}}@media (max-width: 599px){.site-footer,.page-wrap:after{height:40px}}\n", ""]);
// Exports
module.exports = exports;
